import { styled } from "@mui/material/styles";
import { Grid, Typography } from "@mui/material";

export const EmployeeInfoContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "forExport",
})<{ forExport?: boolean }>(
  ({ theme }) => ({
    width: "400px",
    minWidth: "300px",
    height: "calc(100% - 10px)",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    marginTop: "10px",
  }),
  ({ forExport }) => ({
    ...(!!forExport && {
      margin: "0px",
      height: "fit-content",
    }),
  })
);

export const InfoContainer = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  gap: "5px",
  flexWrap: "nowrap",
  alignItems: "flex-start",
});

export const IconsContainer = styled(Grid)({
  width: "30px",
});

export const NameContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
});

export const DateDocumentContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "readOnly",
})<{ readOnly?: boolean }>(
  ({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "10px",
  }),
  ({ readOnly }) => ({
    ...(!!readOnly && {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "0px",
    }),
  })
);

export const DescriptionsContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "readOnly",
})<{ readOnly?: boolean }>(({ readOnly }) => ({
  ...(!!readOnly && {
    width: "100%",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
  }),
}));

export const BusinessDescriptionContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "isReadOnlyWithoutDoc",
})<{ isReadOnlyWithoutDoc?: boolean }>(
  ({ theme }) => ({
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "10px",
  }),
  ({ isReadOnlyWithoutDoc }) => ({
    ...(!!isReadOnlyWithoutDoc && {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "0px",
    }),
  })
);

export const TitleName = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.disabled,
}));
